/**
 * Compact relative-time strings for comment timestamps:
 *   "just now", "3 minutes ago", "6 hours ago", "2 days ago", "Apr 27".
 *
 * Handles future timestamps gracefully ("just now"). Locale-aware month
 * formatting falls back to en-US.
 */
export function relativeTime(ms: number, now: number = Date.now()): string {
  const diff = Math.max(0, now - ms);
  const sec = Math.round(diff / 1000);
  if (sec < 30) return 'just now';
  if (sec < 90) return '1 minute ago';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} minutes ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return hr === 1 ? '1 hour ago' : `${hr} hours ago`;
  const d = Math.round(hr / 24);
  if (d < 7) return d === 1 ? '1 day ago' : `${d} days ago`;
  const date = new Date(ms);
  const sameYear = date.getFullYear() === new Date(now).getFullYear();
  return date.toLocaleDateString(undefined, sameYear
    ? { month: 'short', day: 'numeric' }
    : { month: 'short', day: 'numeric', year: 'numeric' });
}
